import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { PaintBrushIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

const tabBase =
  'inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors ';

const tabInactive =
  tabBase + 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800';
const tabActive =
  tabBase + 'bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-200';

const PreferencesLayout: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Preferencias</h1>

      <nav className="flex flex-wrap gap-2 border-b border-gray-200 dark:border-gray-700 pb-4 mb-6">
        <NavLink
          to="/preferences"
          end
          className={({ isActive }) => (isActive ? tabActive : tabInactive)}
        >
          <PaintBrushIcon className="w-5 h-5" />
          Tema
        </NavLink>
        <NavLink
          to="/preferences/apps"
          className={({ isActive }) => (isActive ? tabActive : tabInactive)}
        >
          <DevicePhoneMobileIcon className="w-5 h-5" />
          Apps
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
};

export default PreferencesLayout;
